import { IonReactRouter } from '@ionic/react-router';
import React from 'react';
import { useAuthentication } from '../authentication/authentication-hook';
import PublicAppRoutes from './PublicAppRoutes';
import AppRoutes from './AppRoutes';

export default function AppRouter() {
  const { isAuthenticated } = useAuthentication();

  return (
    <IonReactRouter>
      { isAuthenticated ? <AppRoutes /> : <PublicAppRoutes /> }
    </IonReactRouter>
  );
}
